import React, { FC, Ref, SyntheticEvent } from 'react';
import { CommonComponentProps, CommonFieldProps, StylableComponentProps, InputProps } from '@cld/common-definitions';
import { Root, StyledIcon } from './Checkbox.styled';

export interface CheckboxProps extends CommonFieldProps<boolean, SyntheticEvent<HTMLInputElement>>, StylableComponentProps, CommonComponentProps<'div'> {
  /** Id of the HTML input. */
  id?: string;
  /** Ref forwarded to HTML input element inside. */
  inputRef?: Ref<HTMLInputElement>;
  /** Props passed directly to HTML input inside **(overriding props already handled by abstraction)**. */
  inputProps?: InputProps;
}

/**
 * Use `Checkbox` to control binary value in the form
 */
export const Checkbox: FC<CheckboxProps> = ({
  name,
  id,
  inputRef,
  value,
  defaultValue,
  onChange,
  onClick,
  onFocus,
  onBlur,
  isDisabled = false,
  validationState = false,
  className,
  rootProps,
  inputProps,
}) => {
  const handleOnChange = (event: SyntheticEvent<HTMLInputElement>) => onChange?.(event.currentTarget.checked, event);

  return (
    <Root onClick={onClick} isChecked={!!value} isDisabled={isDisabled} hasError={validationState === 'error'} className={className} {...rootProps}>
      <input
        name={name}
        id={id}
        type="checkbox"
        value={String(value)}
        checked={value}
        defaultChecked={defaultValue}
        aria-checked={value}
        disabled={isDisabled}
        onChange={handleOnChange}

        onFocus={onFocus}
        onBlur={onBlur}
        ref={inputRef}
        {...inputProps}
      />
      <StyledIcon name="check" />
    </Root>
  );
};
